/**
 * Warenkorb-Upsell "Das könnte dir auch gefallen" (snippets/cart-upsell.liquid)
 *
 * - Ein Klick-Handler am document (funktioniert auch nach jedem Neuaufbau des Drawers)
 * - Eine Variante: "Hinzufügen" legt direkt in den Warenkorb
 * - Mehrere Varianten: Auswahl klappt unter der Zeile auf (Daten aus dem JSON der Karte)
 * - Danach baut sich der Drawer wie beim normalen "In den Warenkorb" neu auf
 *   (cart-drawer.renderContents + PUB_SUB cartUpdate) – das Produkt verschwindet
 *   dann automatisch aus den Vorschlägen.
 */
(function () {
  if (window.SterntalerCartUpsell) return;
  window.SterntalerCartUpsell = true;

  var COLOR_RE = /(farbe|colou?r)/i;
  var SIZE_RE = /(größe|grösse|groesse|size)/i;

  function money(cents) {
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function optionLabel(name) {
    var inner = String(name).match(/\(([^)]+)\)\s*$/);
    var key = inner ? inner[1] : name;
    if (COLOR_RE.test(key) || COLOR_RE.test(name)) return 'Farbe';
    if (SIZE_RE.test(key) || SIZE_RE.test(name)) return 'Größe';
    return String(name).replace(/\s*\([^)]*\)\s*$/, '');
  }

  /* ---------------- Daten je Karte ---------------- */
  function getData(item) {
    if (item._cu) return item._cu;
    var el = item.querySelector('[data-cu-product]');
    var data = { options: [], variants: [] };
    try { data = JSON.parse(el.textContent); } catch (e) {}
    data.options = (data.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    data.selected = data.options.map(function () { return null; });
    item._cu = data;
    return data;
  }

  // Werte einer Option, die zusammen mit den übrigen Auswahlen verfügbar sind
  function isPossible(data, idx, value) {
    return data.variants.some(function (v) {
      if (!v.available || v.options[idx] !== value) return false;
      for (var i = 0; i < data.options.length; i++) {
        if (i !== idx && data.selected[i] && v.options[i] !== data.selected[i]) return false;
      }
      return true;
    });
  }

  function valuesOf(data, idx) {
    var out = [];
    data.variants.forEach(function (v) {
      if (out.indexOf(v.options[idx]) === -1) out.push(v.options[idx]);
    });
    // nur Werte, für die es überhaupt eine verfügbare Variante gibt
    return out.filter(function (val) {
      return data.variants.some(function (v) { return v.available && v.options[idx] === val; });
    });
  }

  // "_model"-Bild? (Dateiname vor Endung/Größenzusatz endet auf _model)
  function isModel(url) {
    var file = String(url || '').split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '');
    return /_model(_\d+x\d*)?$/i.test(file);
  }

  function swatchFor(data, idx, value) {
    var hit = data.variants.find(function (v) { return v.options[idx] === value && v.swatch; });
    return hit ? hit.swatch : null;
  }

  function currentVariant(data) {
    if (data.selected.some(function (s) { return !s; })) return null;
    return data.variants.find(function (v) {
      return v.available && v.options.every(function (o, i) { return o === data.selected[i]; });
    }) || null;
  }

  /* ---------------- Auswahl darstellen ---------------- */
  function renderPicker(item) {
    var data = getData(item);
    var wrap = item.querySelector('[data-cu-options]');
    if (!wrap) return;

    // Optionen mit nur einem möglichen Wert automatisch wählen
    data.options.forEach(function (name, idx) {
      var vals = valuesOf(data, idx);
      if (vals.length === 1) data.selected[idx] = vals[0];
      if (data.selected[idx] && !isPossible(data, idx, data.selected[idx])) data.selected[idx] = null;
    });

    wrap.innerHTML = '';
    data.options.forEach(function (name, idx) {
      var vals = valuesOf(data, idx);
      if (vals.length < 2) return; // nichts zu wählen
      var group = document.createElement('div');
      group.className = 'cu-opt';
      group.setAttribute('role', 'group');

      var label = document.createElement('p');
      label.className = 'cu-opt__label';
      label.id = 'CuOpt-' + item.dataset.productId + '-' + idx;
      label.textContent = optionLabel(name);
      if (data.selected[idx]) {
        var val = document.createElement('span');
        val.textContent = ': ' + data.selected[idx];
        label.appendChild(val);
      }
      group.setAttribute('aria-labelledby', label.id);
      group.appendChild(label);

      var list = document.createElement('div');
      list.className = 'cu-opt__values';
      var isColor = COLOR_RE.test(name);
      if (isColor) list.className += ' cu-opt__values--swatch';
      vals.forEach(function (value) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = isColor ? 'cu-swatch' : 'cu-opt__btn';
        if (isColor) {
          // Farbkachel wie auf der PDP: Freisteller (…_M) bzw. Variantenbild + Farbname
          var src = swatchFor(data, idx, value);
          var box = document.createElement('span');
          box.className = 'cu-swatch__img';
          if (src) {
            var im = document.createElement('img');
            im.src = src; im.alt = ''; im.loading = 'lazy'; im.width = 56; im.height = 56;
            if (isModel(src)) im.className = 'is-model';
            box.appendChild(im);
          }
          var cap = document.createElement('span');
          cap.className = 'cu-swatch__name';
          cap.textContent = value;
          b.appendChild(box);
          b.appendChild(cap);
          b.setAttribute('aria-label', value);
        } else {
          b.textContent = value;
        }
        b.dataset.cuOpt = String(idx);
        b.dataset.value = value;
        b.setAttribute('aria-pressed', String(data.selected[idx] === value));
        if (!isPossible(data, idx, value)) b.disabled = true;
        list.appendChild(b);
      });
      group.appendChild(list);
      wrap.appendChild(group);
    });
    updateSelection(item);
  }

  function updateSelection(item) {
    var data = getData(item);
    var confirm = item.querySelector('[data-cu-confirm]');
    var variant = currentVariant(data);
    if (confirm) {
      confirm.disabled = !variant;
      if (!confirm.dataset.label) confirm.dataset.label = confirm.textContent.trim();
      if (variant) {
        confirm.innerHTML = '<span></span>';
        confirm.firstChild.textContent = confirm.dataset.label + ' · ' + money(variant.price);
      } else {
        var missing = data.options.map(function (n, i) { return data.selected[i] ? null : optionLabel(n); }).filter(Boolean);
        confirm.innerHTML = '<span></span>';
        confirm.firstChild.textContent = missing.length ? 'Bitte ' + missing.join(' & ') + ' wählen' : 'Nicht verfügbar';
      }
    }
    // Preis der gewählten Variante
    var priceEl = item.querySelector('[data-cu-price]');
    if (priceEl && variant) {
      if (!priceEl.dataset.initial) priceEl.dataset.initial = priceEl.innerHTML;
      priceEl.textContent = money(variant.price);
      if (variant.compare > variant.price) {
        var s = document.createElement('s'); s.textContent = money(variant.compare); priceEl.appendChild(s);
      }
      priceEl.classList.toggle('cu-item__price--sale', variant.compare > variant.price);
    }
    // Bild der gewählten Farbe zeigen
    var img = item.querySelector('[data-cu-img]');
    if (img) {
      var match = data.variants.find(function (v) {
        return v.image && data.options.every(function (n, i) {
          return !COLOR_RE.test(n) || !data.selected[i] || v.options[i] === data.selected[i];
        });
      });
      if (match && match.image && img.getAttribute('src') !== match.image) {
        img.setAttribute('src', match.image);
        var box = img.closest('.cu-item__media');
        if (box) box.classList.toggle('cu-item__media--model', isModel(match.image));
      }
    }
  }

  function togglePicker(item, btn) {
    var picker = item.querySelector('[data-cu-picker]');
    if (!picker) return;
    var open = picker.hidden;
    // andere offene Auswahl schließen
    document.querySelectorAll('[data-cu-item] [data-cu-picker]:not([hidden])').forEach(function (p) {
      if (p !== picker) {
        p.hidden = true;
        var t = p.closest('[data-cu-item]').querySelector('[data-cu-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
    picker.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    if (open) {
      renderPicker(item);
      var first = picker.querySelector('.cu-opt__btn:not(:disabled)');
      if (first) first.focus({ preventScroll: true });
      if (picker.scrollIntoView) picker.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  /* ---------------- In den Warenkorb ---------------- */
  function showError(item, msg) {
    var el = item && item.querySelector('[data-cu-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function addToCart(item, variantId, btn) {
    if (!variantId || btn.classList.contains('is-loading')) return;
    showError(item, '');
    btn.classList.add('is-loading');
    btn.disabled = true;
    if (!btn.querySelector('span')) btn.innerHTML = '<span>' + btn.textContent + '</span>';

    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, properties: { _upsell: 'cart_drawer' } }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          throw new Error((res.data && (res.data.description || res.data.message)) || 'Der Artikel konnte nicht hinzugefügt werden.');
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', productVariantId: Number(variantId), cartData: res.data });
        }
        if (drawer && typeof drawer.renderContents === 'function' && res.data.sections) {
          drawer.renderContents(res.data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
        try { window.dispatchEvent(new CustomEvent('sterntaler-cart-update', { detail: { source: 'cart-upsell' } })); } catch (e) {}
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        showError(item, err && err.message ? err.message : 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
      });
  }

  /* ---------------- Klicks ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var item = t.closest('[data-cu-item]');
    if (!item) return;

    var add = t.closest('[data-cu-add]');
    if (add) { e.preventDefault(); addToCart(item, add.dataset.variantId, add); return; }

    var toggle = t.closest('[data-cu-toggle]');
    if (toggle) { e.preventDefault(); togglePicker(item, toggle); return; }

    var opt = t.closest('[data-cu-opt]');
    if (opt && !opt.disabled) {
      e.preventDefault();
      var data = getData(item);
      var idx = Number(opt.dataset.cuOpt);
      data.selected[idx] = data.selected[idx] === opt.dataset.value && valuesOf(data, idx).length > 1 ? null : opt.dataset.value;
      renderPicker(item);
      var again = item.querySelector('[data-cu-opt="' + idx + '"][data-value="' + CSS.escape(opt.dataset.value) + '"]');
      if (again) again.focus({ preventScroll: true });
      return;
    }

    var confirm = t.closest('[data-cu-confirm]');
    if (confirm && !confirm.disabled) {
      e.preventDefault();
      var v = currentVariant(getData(item));
      if (v) addToCart(item, v.id, confirm);
    }
  });
})();